module.exports = "/_next/static/images/10e550dad5598ecefc0083fd46a81e50-open-graph.jpg";